"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileSingleUpload = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var __1 = require("..");
var Alert_1 = require("../Alert");
require("./fileSingleUpload.css");
exports.FileSingleUpload = React.memo(function (_a) {
    var _b = _a.fileSizeLimit, fileSizeLimit = _b === void 0 ? 2 * 1024 * 1024 : _b, props = __rest(_a, ["fileSizeLimit"]);
    var _c = React.useState(false), sizeAlert = _c[0], setSizeAlert = _c[1];
    var addFileFromFilelist = function (fileList, fileSlug) {
        (0, function_1.pipe)(O.some(Array.from(fileList)), O.filter(function (f) { return !f.reduce(function (carry, file) { return carry || file.size >= fileSizeLimit; }, false); }), O.map(function (f) {
            var fileToUpload = f[0];
            props.onSelect(fileToUpload, fileSlug);
            setSizeAlert(false);
        }), O.getOrElse(function () {
            setSizeAlert(true);
        }));
    };
    var onChange = function (fileSlug) { return function (e) {
        e.target.files !== null && addFileFromFilelist(e.target.files, fileSlug);
        e.target.value = '';
    }; };
    var renderSizeAlert = function () {
        return sizeAlert ? ((0, jsx_runtime_1.jsxs)(Alert_1.Alert, __assign({ type: "danger" }, { children: ["Non \u00E8 possibile caricare file con dimensioni maggiori di", ' ', (0, jsx_runtime_1.jsx)(__1.FieldFormatter.Bytes, { size: fileSizeLimit }), "!"] }))) : null;
    };
    var renderIcon = function (d) {
        switch (d.uploadStatus) {
            case 'not_uploaded':
                return ((0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 1.5 }, { children: (0, jsx_runtime_1.jsx)(__1.Button, __assign({ className: "single-upload-button", icon: "icon_upload", styleType: "primary-inv", radius: true, size: "sm" }, { children: (0, jsx_runtime_1.jsx)("input", { className: "single-upload-input", type: "file", multiple: true, onChange: onChange(d.slug), accept: props.acceptedTypes ? props.acceptedTypes.join(',') : '*' }) })) })));
            case 'uploaded':
                return ((0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xsOffset: 0.5, xs: 1 }, { children: (0, jsx_runtime_1.jsx)(__1.Icon, { theme: "success", size: "lg", icon: "icon_check_dark" }) })));
            case 'cannot_upload':
                return (0, jsx_runtime_1.jsx)(__1.FlexView.Item, { xsOffset: 0.5, xs: 1 });
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "file-single-upload" }, { children: [renderSizeAlert(), (0, jsx_runtime_1.jsx)(__1.BackGround, __assign({ color: "soft-grey", border: { type: 'light-grey', style: 'no-bottom' }, radius: "top" }, { children: (0, jsx_runtime_1.jsx)(__1.TextFormatter, __assign({ borderless: true, fontSize: "base", fontWeight: "bold" }, { children: props.title })) })), props.documents.map(function (d, i) { return ((0, jsx_runtime_1.jsx)(__1.BackGround, __assign({ color: "white", border: {
                    type: 'light-grey',
                    style: i < props.documents.length - 1 ? 'no-bottom' : 'all',
                }, radius: i < props.documents.length - 1 ? 'none' : 'bottom' }, { children: (0, jsx_runtime_1.jsxs)(__1.FlexView, __assign({ hAlignContent: "between", vAlignContent: "center" }, { children: [(0, jsx_runtime_1.jsx)(__1.FlexView.Item, __assign({ xs: 10.5 }, { children: (0, jsx_runtime_1.jsx)(__1.TextFormatter, __assign({ borderless: true, fontSize: "base", fontWeight: "bold" }, { children: d.label })) })), renderIcon(d)] })) }), d.slug)); })] })));
});
//# sourceMappingURL=FileSingleUpload.js.map